"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { useLanguage } from "@/contexts/LanguageContext";

export default function Footer() {
  const pathname = usePathname();
  const { t } = useLanguage();

  const handleHashLink = (e: React.MouseEvent<HTMLAnchorElement>, hash: string) => {
    if (pathname === "/homepage") {
      e.preventDefault();
      const el = document.getElementById(hash);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const linkStyle = {
    fontFamily: "Rajdhani, sans-serif",
    fontWeight: 500,
    fontSize: "0.7rem",
    letterSpacing: "0.15em",
    textTransform: "uppercase" as const,
    color: "#555555",
    textDecoration: "none",
    transition: "color 0.2s ease",
  };

  return (
    <footer
      className="border-t"
      style={{
        backgroundColor: "#0A0A0A",
        borderColor: "#2A2A2A",
        padding: "24px 0",
      }}
    >
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-4">
        <p
          style={{
            fontFamily: "Rajdhani, sans-serif",
            fontWeight: 500,
            fontSize: "0.75rem",
            letterSpacing: "0.15em",
            textTransform: "uppercase",
            color: "#555555",
          }}
        >
          {t.footerRights}
        </p>
        <div className="flex items-center gap-6 flex-wrap justify-center">
          <Link href="/homepage" style={linkStyle} className="hover:text-white">{t.navHome}</Link>
          <Link href="/machines" style={linkStyle} className="hover:text-white">{t.navMachines}</Link>
          <Link href="/pricing" style={linkStyle} className="hover:text-white">{t.navSubscription}</Link>
          <Link
            href="/homepage#om-oss"
            style={linkStyle}
            className="hover:text-white"
            onClick={(e) => handleHashLink(e, "om-oss")}
          >
            {t.navAbout}
          </Link>
          <Link
            href="/homepage#kontakt"
            style={linkStyle}
            className="hover:text-white"
            onClick={(e) => handleHashLink(e, "kontakt")}
          >
            {t.navContact}
          </Link>
          <Link href="/blogg" style={linkStyle} className="hover:text-white">{t.footerBlog}</Link>
          <Link href="/karriere" style={linkStyle} className="hover:text-white">{t.footerKarriere}</Link>
          <Link href="/partnere" style={linkStyle} className="hover:text-white">{t.footerPartnere}</Link>
          <Link href="/status" style={linkStyle} className="hover:text-white">{t.footerStatus}</Link>
          <span
            style={{
              fontFamily: "Rajdhani, sans-serif",
              fontSize: "0.7rem",
              letterSpacing: "0.15em",
              textTransform: "uppercase",
              color: "#333333",
            }}
          >
            {t.footerLang}
          </span>
        </div>
      </div>
    </footer>
  );
}